import { shouldRetryApplicationQuery } from "@client/offline/queryRetryPolicy";
import { getIsOnline } from "@client/hooks/useNetworkStatus";
import { trpc } from "@client/trpc";
import { isApplicationSourceRevoked } from "@client/offline/artifactQueryPersistence";

const retry = (failureCount: number, error: unknown) =>
  shouldRetryApplicationQuery({ failureCount, error, isOnline: getIsOnline() });

/** Display and copy share the persisted source and the same server-error policy. */
export function useProposalApplication(
  input: { roundId: string; proposalId: string },
  enabled = true,
) {
  const query = trpc.getProposalApplication.useQuery(input, { enabled, retry });
  return readableApplicationQuery(query, enabled);
}

function readableApplicationQuery<T>(
  query: {
    data: T | undefined;
    error: { data?: unknown; message: string } | null;
    failureReason: { data?: unknown; message: string } | null;
  },
  enabled: boolean,
) {
  const failure = query.error ?? query.failureReason;
  const error =
    failure && (query.data === undefined || isApplicationSourceRevoked(failure))
      ? failure
      : null;
  return { data: enabled && !error ? query.data : undefined, error };
}

export function useProposalApplicationSearch(
  roundId: string,
  enabled: boolean,
) {
  const query = trpc.getProposalApplicationSearch.useQuery(
    { roundId },
    { enabled, staleTime: 0, refetchOnWindowFocus: true, retry },
  );
  return readableApplicationQuery(query, enabled);
}
